import { render, staticRenderFns } from "./ProductCreateDialog.vue?vue&type=template&id=366f5f91"
import script from "./ProductCreateDialog.vue?vue&type=script&lang=js"
export * from "./ProductCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports